import { render, staticRenderFns } from "./RowCallRules.vue?vue&type=template&id=6568c487"
import script from "./RowCallRules.vue?vue&type=script&lang=js"
export * from "./RowCallRules.vue?vue&type=script&lang=js"
import style0 from "./RowCallRules.vue?vue&type=style&index=0&id=6568c487&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports